import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function FeaturedProject() {
  return (
    <section className="project" id="projects" aria-labelledby="projects-heading">
      <div className="project-inner">
        <div className="project-header">
          <span className="eyebrow reveal">Current work</span>
          <h2 id="projects-heading" className="reveal">What we&rsquo;re building.</h2>
        </div>
        <article className="project-card reveal">
          <div className="project-image" role="img" aria-label="Rendering coming soon">
            <span className="project-image-caption">Rendering &mdash; coming soon</span>
          </div>
          <div className="project-details">
            <span className="project-status">In planning</span>
            <h3>A new kind of neighborhood for Berthoud</h3>
            <p className="project-location">Berthoud, Colorado</p>
            <p>
              A connected, walkable community designed to solve real needs and honor the town&rsquo;s character.
              Shaped by local input, built with intention, and planned for generations.
            </p>
            <a href="#contact" className="project-link">
              Start a conversation about this project
              <ArrowRight aria-hidden="true" />
            </a>
          </div>
        </article>
      </div>
    </section>
  );
}
